export const GET_GOVERNORATES = "GET_GOVERNORATES";
export const GET_GOVERNORATES_SUCCESS = "GET_GOVERNORATES_SUCCESS";
export const GET_GOVERNORATES_ERROR = "GET_GOVERNORATES_ERROR";
export const TOGGLE_GOVERNORATE_MODAL = "TOGGLE_GOVERNORATE_MODAL";

export const ADD_GOVERNORATE = "ADD_GOVERNORATE";
export const ADD_GOVERNORATE_SUCCESS = "ADD_GOVERNORATE_SUCCESS";
export const ADD_GOVERNORATE_ERROR = "ADD_GOVERNORATE_ERROR";

export const GET_GOVERNORATE = "GET_GOVERNORATE";
export const GET_GOVERNORATE_SUCCESS = "GET_GOVERNORATE_SUCCESS";
export const GET_GOVERNORATE_ERROR = "GET_GOVERNORATE_ERROR";

export const UPDATE_GOVERNORATE = "UPDATE_GOVERNORATE";
export const UPDATE_GOVERNORATE_SUCCESS = "UPDATE_GOVERNORATE_SUCCESS";
export const UPDATE_GOVERNORATE_ERROR = "UPDATE_GOVERNORATE_ERROR";

export const DELETE_GOVERNORATE = "DELETE_GOVERNORATE";
export const DELETE_GOVERNORATE_SUCCESS = "DELETE_GOVERNORATE_SUCCESS";
export const DELETE_GOVERNORATE_ERROR = "DELETE_GOVERNORATE_ERROR";

export const GET_GOVERNORATES_SELECT_LIST = "GET_GOVERNORATES_SELECT_LIST";
export const GET_GOVERNORATES_SELECT_LIST_SUCCESS =
  "GET_GOVERNORATES_SELECT_LIST_SUCCESS";
export const GET_GOVERNORATES_SELECT_LIST_ERROR =
  "GET_CATEGORIES_SELECT_LIST_ERROR";
